import React from 'react';
import { useIntl } from 'react-intl';

import { TranslationKeys } from '../translations';
import { EmploymentTypeEnum } from '../types/employee.types';

export const useEmploymentTypeSelectItems = () => {
  const intl = useIntl();

  const employmentTypeSelectItems = React.useMemo(() => {
    return [
      {
        element: intl.formatMessage({ id: TranslationKeys.global_employmentType_indefinite }),
        value: EmploymentTypeEnum.Indefinite,
      },
      {
        element: intl.formatMessage({ id: TranslationKeys.global_employmentType_definite }),
        value: EmploymentTypeEnum.Definite,
      },
    ];
  }, [intl]);

  const getEmploymentTypeDisplayNameByValue = React.useCallback(
    (value: EmploymentTypeEnum) => {
      return employmentTypeSelectItems.find(employmentType => employmentType.value === value)?.element;
    },
    [employmentTypeSelectItems],
  );

  return React.useMemo(
    () => ({ employmentTypeSelectItems, getEmploymentTypeDisplayNameByValue }),
    [employmentTypeSelectItems, getEmploymentTypeDisplayNameByValue],
  );
};
